/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-13 19:57:28
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-04-29 14:02:51
 */
import type { RouteRecordRaw } from 'vue-router'
const { portingConfig } = usePortingConfig()
export const constantRouter: RouteRecordRaw[] = [
  {
    path: '',
    redirect: { path: portingConfig.redirectPath || '/login' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/index')
  },
  {
    path: '/bs',
    name: 'nmLogin',
    component: () => import('@/pages/login/index')
  },
  {
    path: '/bszh',
    name: 'bszh',
    component: () => import('@/pages/login/index')
  },
  {
    path: '/login/:orgCode',
    name: 'customLogin',
    component: () => import('@/pages/login/index')
  },
  {
    path: '/baoming/:orgCode',
    name: 'baoming',
    component: () => import('@/views/baoming/index.vue')
  },
  {
    path: '/detect',
    name: 'detect',
    component: () => import('@/views/detect/index.vue'),
    meta: {
      title: '设备检测'
    }
  },
  {
    path: '/new-detect',
    name: 'newDetect',
    component: () => import('@/views/newDetect/index.vue'),
    meta: {
      title: '设备调试'
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import('@/views/privacyPolicy/index.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/report/index.vue'),
    meta: {
      title: '报告'
    }
  },
  {
    path: '/aiInterview',
    name: 'aiInterview',
    component: () => import('@/views/aiInterview/index.vue'),
    meta: {
      title: 'AI面试'
    }
  },
  {
    path: '/evaInfo/acti/:id',
    name: 'actiEvaInfo',
    component: () => import('@/views/evaInfo/index.vue'),
    meta: {
      title: '个人信息'
    }
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/history/index.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/views/activity/index.vue'),
    children: [
      {
        path: 'evaluation',
        name: 'evaluation',
        component: () => import('@/views/activity/evaluation.vue')
      },
      {
        path: 'interview',
        name: 'interview',
        component: () => import('@/views/activity/interview.vue')
      },
      {
        path: 'remarking',
        name: 'remarking',
        component: () => import('@/views/activity/remarking.vue')
      },
      {
        path: 'review',
        name: 'review',
        component: () => import('@/views/activity/review.vue')
      }
    ],
    meta: {
      title: '问卷列表'
    }
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: () => import('@/views/instructions/index.vue'),
    meta: {
      title: '问卷说明'
    }
  },
  {
    path: '/aiInstructions',
    name: 'aiInstructions',
    component: () => import('@/views/aiInstructions/index.vue'),
    meta: {
      title: 'AI面试引导'
    }
  },
  {
    path: '/paper',
    name: 'paper',
    component: () => import('@/views/paper/index'),
    meta: {
      title: '问卷'
    }
  },
  {
    path: '/survey',
    name: 'survey',
    component: () => import('@/views/survey/index.vue'),
    meta: {
      title: '调查问卷'
    }
  },
  {
    path: '/marking',
    name: 'markingPaper',
    component: () => import('@/views/marking/index.vue'),
    meta: {
      title: '阅卷'
    }
  },
  {
    path: '/interview/room',
    name: 'interviewRoom',
    component: () => import('@/views/interview/index.vue'),
    meta: {
      title: '面试间'
    }
  },
  {
    path: '/review/index',
    name: 'reviewDetail',
    component: () => import('@/views/review/index.vue'),
    meta: {
      title: '审核'
    }
  },
  {
    path: '/paper-config',
    name: 'paperConfig',
    component: () => import('@/views/paper/index')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/feedback/index.vue'),
    meta: {
      title: '反馈'
    }
  },
  {
    path: '/test/aliyun-upload',
    name: 'aliyunUploadTest',
    component: () => import('@/views/test/AliyunUpload.vue'),
    meta: {
      title: '阿里云视频上传压测'
    }
  }
]
